import type { ThemePalette } from "./types";

export const catppuccinMocha: ThemePalette = {
	id: "catppuccin-mocha",
	name: "Catppuccin Mocha",
	family: "catppuccin",
	appearance: "dark",

	background: "#1e1e2e",
	foreground: "#cdd6f4",
	card: "#181825",
	cardForeground: "#cdd6f4",
	popover: "#181825",
	popoverForeground: "#cdd6f4",

	primary: "#cba6f7",
	primaryForeground: "#11111b",
	secondary: "#313244",
	secondaryForeground: "#cdd6f4",
	muted: "#313244",
	mutedForeground: "#7f849c",
	accent: "#f5c2e7",
	accentForeground: "#11111b",
	destructive: "#f38ba8",
	destructiveForeground: "#11111b",

	border: "#45475a",
	input: "#45475a",
	ring: "#cba6f7",

	success: "#a6e3a1",
	warning: "#f9e2af",
	error: "#f38ba8",
	info: "#89b4fa",

	chart1: "#cba6f7",
	chart2: "#89b4fa",
	chart3: "#fab387",
	chart4: "#f5c2e7",
	chart5: "#a6e3a1",
};

export const catppuccinMacchiato: ThemePalette = {
	id: "catppuccin-macchiato",
	name: "Catppuccin Macchiato",
	family: "catppuccin",
	appearance: "dark",

	background: "#24273a",
	foreground: "#cad3f5",
	card: "#1e2030",
	cardForeground: "#cad3f5",
	popover: "#1e2030",
	popoverForeground: "#cad3f5",

	primary: "#c6a0f6",
	primaryForeground: "#181926",
	secondary: "#363a4f",
	secondaryForeground: "#cad3f5",
	muted: "#363a4f",
	mutedForeground: "#8087a2",
	accent: "#f5bde6",
	accentForeground: "#181926",
	destructive: "#ed8796",
	destructiveForeground: "#181926",

	border: "#494d64",
	input: "#494d64",
	ring: "#c6a0f6",

	success: "#a6da95",
	warning: "#eed49f",
	error: "#ed8796",
	info: "#8aadf4",

	chart1: "#c6a0f6",
	chart2: "#8aadf4",
	chart3: "#f5a97f",
	chart4: "#f5bde6",
	chart5: "#a6da95",
};

export const catppuccinFrappe: ThemePalette = {
	id: "catppuccin-frappe",
	name: "Catppuccin Frapp\u00e9",
	family: "catppuccin",
	appearance: "dark",

	background: "#303446",
	foreground: "#c6d0f5",
	card: "#292c3c",
	cardForeground: "#c6d0f5",
	popover: "#292c3c",
	popoverForeground: "#c6d0f5",

	primary: "#ca9ee6",
	primaryForeground: "#232634",
	secondary: "#414559",
	secondaryForeground: "#c6d0f5",
	muted: "#414559",
	mutedForeground: "#838ba7",
	accent: "#f4b8e4",
	accentForeground: "#232634",
	destructive: "#e78284",
	destructiveForeground: "#232634",

	border: "#51576d",
	input: "#51576d",
	ring: "#ca9ee6",

	success: "#a6d189",
	warning: "#e5c890",
	error: "#e78284",
	info: "#8caaee",

	chart1: "#ca9ee6",
	chart2: "#8caaee",
	chart3: "#ef9f76",
	chart4: "#f4b8e4",
	chart5: "#a6d189",
};

export const catppuccinLatte: ThemePalette = {
	id: "catppuccin-latte",
	name: "Catppuccin Latte",
	family: "catppuccin",
	appearance: "light",

	background: "#eff1f5",
	foreground: "#4c4f69",
	card: "#e6e9ef",
	cardForeground: "#4c4f69",
	popover: "#e6e9ef",
	popoverForeground: "#4c4f69",

	primary: "#8839ef",
	primaryForeground: "#dce0e8",
	secondary: "#ccd0da",
	secondaryForeground: "#4c4f69",
	muted: "#ccd0da",
	mutedForeground: "#8c8fa1",
	accent: "#ea76cb",
	accentForeground: "#dce0e8",
	destructive: "#d20f39",
	destructiveForeground: "#dce0e8",

	border: "#bcc0cc",
	input: "#bcc0cc",
	ring: "#8839ef",

	success: "#40a02b",
	warning: "#df8e1d",
	error: "#d20f39",
	info: "#1e66f5",

	chart1: "#8839ef",
	chart2: "#1e66f5",
	chart3: "#fe640b",
	chart4: "#ea76cb",
	chart5: "#40a02b",
};
